export default class Result<T> {
    public value: T;
    public errors: { [id: string]: any };
    public errorMessage: string;
    public get hasErrors(): boolean {

        return (this.errors != null && this.errors != undefined)
            || (this.errorMessage && this.errorMessage.length > 0);
        /*return this.errors != null && this.errors != undefined
            && ((Array.isArray(this.errors) && this.errors.length > 0)
            || (this.errors != undefined && Object.keys(this.errors).length > 0));*/
    }

    constructor(value: T, errors: { [id: string]: any }, errorMessage: string) {
        this.value = value;
        if (errors != null)
            this.errors = errors;//[0] == undefined || errors[0] == null ? [] : errors;

        this.errorMessage = errorMessage;
    }

    public static FromValue<T>(value: T) {
        return new Result(value, null, null);
    }

    public static FromErrors(errors: { [id: string]: any }, errorMessage: string) {
        return new Result(null, errors, errorMessage);
    }
}